/** @jsx jsx */

import type { HTMLAttributes } from 'react';
import { jsx } from '@balance-web/core';

/** Position the loading indicator */
export const Center = (props: HTMLAttributes<HTMLSpanElement>) => {
  return (
    <span
      css={{
        left: '50%',
        position: 'absolute',
        transform: 'translateX(-50%)',
      }}
      {...props}
    />
  );
};
